import { createIcon } from '@chakra-ui/react';

export const StatsFailedIcon = createIcon({
  displayName: 'StatsFailedIcon',
  viewBox: '0 0 48 48',
  defaultProps: {
    fill: 'none',
    height: '48',
    width: '48',
  },
  path: (
    <>
      <circle cx="24" cy="24" r="24" fill="#FFE3E3" />
      <path
        d="M24 10.666C31.3637 10.666 37.3328 16.6354 37.333 23.999C37.333 31.3628 31.3638 37.332 24 37.332C16.6363 37.3319 10.667 31.3627 10.667 23.999C10.6672 16.6354 16.6364 10.6661 24 10.666ZM24 22.1133L18.667 16.7803L16.7812 18.666L22.1152 23.999L16.7822 29.333L18.667 31.2178L24 25.8838L29.334 31.2178L31.2188 29.333L25.8848 23.999L31.2188 18.666L29.334 16.7803L24 22.1133Z"
        fill="#AB091E"
      />
    </>
  ),
});
